import { BOPatientRiskFactor } from '../BOPatientRiskFactor.model';

export class BOTransPatientRiskFactor {
    patientRiskFactors:BOPatientRiskFactor[]=[];
    patientId:number;
}
